import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "./../../../utils/CustomModal/CustomModal";
import ItemInfo from "./../../../utils/ItemInfo/ItemInfo";
import { convertDate, numberSeparate } from "../../../utils";
import { useDiscountAdminContext } from "../../../context/Admin/UseDiscountAdminContext/UseDiscountAdminContext";
import { ConvertCurrency } from "../../../utils/Currency/Currency";

const UseDiscountAdmin = () => {
  const {
    users,
    user,
    search,
    setSearch,
    pageNumber,
    setPageNumber,
    totalCount,
    isShowDetailsModal,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleGetUseDiscounts,
  } = useContext(useDiscountAdminContext);

  useEffect(() => {
    handleGetUseDiscounts();
  }, [pageNumber]);

  return (
    <>
      <SiteTitle title="کدهای تخفیف استفاده شده" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "کدهای تخفیف استفاده شده", type: "a" },
        ]}
        title="لیست کدهای تخفیف استفاده شده"
      />

      <CardLayout>
        <form className="input-group mb-3" onSubmit={handleGetUseDiscounts}>
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>

        {isEmpty(users) ? (
          <EmptyData />
        ) : (
          <>
            <PaginationList
              setPageNumber={setPageNumber}
              pageCount={totalCount / 10}
            />
            <Table responsive hover borderless striped>
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>کاربر</th>
                  <th>نوع کاربر</th>
                  <th>کد پرسنلی</th>
                  <th>عنوان تخفیف</th>
                  <th>کد تخفیف</th>
                  <th>مبلغ تخفیف</th>
                  <th>نوع خدمت</th>
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {users.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.client}</td>
                    <td>{_item.client_type}</td>
                    <td>{_item.employee_code}</td>
                    <td>{_item.discount_title}</td>
                    <td>{_item.discount_ref_num}</td>
                    <td>{numberSeparate(_item.discount_amount)}</td>
                    <td>{_item.service_type}</td>
                    <td className="mw-25">
                      <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات تخفیف"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="کاربر">
              <p>{user.client}</p>
            </ItemInfo>
            <ItemInfo label="نوع کاربر">
              <p>{user.client_type}</p>
            </ItemInfo>
            <ItemInfo label="کدپرسنلی">
              <p>{user.employee_code}</p>
            </ItemInfo>
            <ItemInfo label="کد تخفیف">
              <p>{user.discount_ref_num}</p>
            </ItemInfo>
            <ItemInfo label="عنوان تخفیف">
              <p>{user.discount_title}</p>
            </ItemInfo>
            <ItemInfo label="درصد تخفیف">
              <p>{user.discount_percent}%</p>
            </ItemInfo>
            <ItemInfo label="مبلغ تخفیف">
              <ConvertCurrency price={user.discount_amount} />
            </ItemInfo>
            <ItemInfo label="توضیحات تخفیف">
              <p>{user.discount_description}</p>
            </ItemInfo>
            <ItemInfo label="تاریخ انقضای تخفیف">
              <p>{convertDate(user.discount_expiration_date)}</p>
            </ItemInfo>
            <ItemInfo label="حداکثر مقدار تخفیف">
              <p>{user.discount_max_discount_amount}</p>
            </ItemInfo>
            <ItemInfo label="حداقل مبلغ فاکتور">
              <p>{user.discount_min_invoice_amount}</p>
            </ItemInfo>
            <ItemInfo label="نام پرسنل">
              <p>{user.personnel}</p>
            </ItemInfo>
            <ItemInfo label="شماره موبایل پرسنل">
              <p>{user.personnel_mobile}</p>
            </ItemInfo>
            <ItemInfo label="زمان حضور">
              <p>{convertDate(user.present_time)}</p>
            </ItemInfo>
            <ItemInfo label="تاریخ ایجاد خدمت">
              <p>{convertDate(user.service_created)}</p>
            </ItemInfo>
            <ItemInfo label="نوع خدمت">
              <p>{user.service_type}</p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default UseDiscountAdmin;
